import React, { useState } from "react";
import {
  MdOutlineAnalytics,
  MdGridView,
  MdOutlineSettings,
  MdOutlineStarOutline,
} from "react-icons/md";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/system";
import "./CookiesMain.css";

const GreenSwitch = styled(Switch)(() => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "green",
    "&:hover": {
      backgroundColor: "rgba(0, 128, 0, 0.1)",
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "green",
  },
}));

export const CookiesDialog = () => {
  const [isAccepted, setIsAccepted] = useState(false);
  const [switchStates, setSwitchStates] = useState({
    analytical: false,
    functional: false,
    performance: false,
  });

  // Temporary state for toggles
  const [tempSwitchStates, setTempSwitchStates] = useState(switchStates);

  const handleRejectAll = () => {
    setTempSwitchStates({
      analytical: false,
      functional: false,
      performance: false,
    });
    setIsAccepted(false);
  };

  const handleAcceptAll = () => {
    setTempSwitchStates({
      analytical: true,
      functional: true,
      performance: true,
    });
    setIsAccepted(false);
  };

  const handleSaveSettings = () => {
    setSwitchStates(tempSwitchStates); // Save the temporary state to the main state
    setIsAccepted(false);
  };

  const handleCloseModal = () => {
    setTempSwitchStates(switchStates); // Reset temporary state to main state
  };

  return (
    <div>
      <button
        onClick={() => document.getElementById("my_modal_3").showModal()}
        className="timeline-item-content"
      >
        <li className="footer_links text-underline">Cookie Preferences</li>
      </button>

      <dialog id="my_modal_3" className="modal" onClose={handleCloseModal}>
        <div className="modal-box modal-box-graident-border text-center">
          <div className="main-bg  rounded-[12px]">
            <form method="dialog">
              <button
                className="btn btn-md btn-circle btn-ghost absolute right-2 top-2 text-[18px] !text-[black] hover:!bg-[#efefef]"
                onClick={handleCloseModal}
              >
                ✕
              </button>
            </form>
            <h3 className="heading p-3 !text-[26px]">
              <span className="text-pent2">Cookie Settings</span>
            </h3>
            <div className="w-[100%] line-divv !mt-0 !mb-0"></div>
            <div className="font-bold text-lg p-3">
              <Box>
                <h1 className="heading pb-3">Cookie Usage</h1>
                <Typography
                  variant="body2"
                  gutterBottom
                  sx={{ color: "black" }}
                >
                  We use cookies to ensure the basic functionalities of the
                  website and to enhance your online experience. You can choose
                  for each category to opt-in/out whenever you want. For more
                  details relative to cookies and other sensitive data, please
                  read the full privacy policy.
                </Typography>
              </Box>
              <Box sx={{ margin: "20px 0px 10px" }}>
                <ul className="list-group">
                  <li className="list-group-item d-flex justify-content-between align-items-center text-[16px] text-[#4f4f4f]">
                    <span className="flex gap-[4px] align-items-center">
                      <MdOutlineStarOutline />
                      Strictly Necessary
                    </span>
                    <Switch
                      disabled
                      defaultChecked
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled": {
                          color: "green",
                          "&:hover": {
                            backgroundColor: "rgba(0, 128, 0, 0.1)",
                          },
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: "green",
                          },
                      }}
                    />
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center text-thin">
                    <div id="accordion" className="w-full">
                      <div className="w-full">
                        <div
                          className="card-header p-0 flex justify-between align-items-center"
                          id="headingOne"
                        >
                          <h5 className="mb-0 !mt-[-3px]">
                            <button
                              className="btn btn-link p-0 !min-h-fit !h-fit text-[16px] text-[#4f4f4f]"
                              data-toggle="collapse"
                              data-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              <MdOutlineAnalytics />
                              Analytical
                            </button>
                          </h5>
                          <GreenSwitch
                            checked={tempSwitchStates.analytical}
                            onChange={() =>
                              setTempSwitchStates((prev) => ({
                                ...prev,
                                analytical: !prev.analytical,
                              }))
                            }
                          />
                        </div>

                        <div
                          id="collapseOne"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          <div className="card-body !py-[12px] !px-0 !font-normal !text-[14px] leading-normal">
                            We&apos;re always striving to improve our .gold
                            domain haven! These cookies anonymously collect data
                            on how visitors use our website, helping us make
                            data-driven decisions to deliver an even better
                            experience for you.
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <div id="accordion" className="w-full">
                      <div className="w-full">
                        <div
                          className="card-header p-0 flex justify-between align-items-center"
                          id="headingTwo"
                        >
                          <h5 className="mb-0 !mt-[-3px]">
                            <button
                              className="btn btn-link p-0 !min-h-fit !h-fit text-[16px] text-[#4f4f4f]"
                              data-toggle="collapse"
                              data-target="#collapseTwo"
                              aria-expanded="true"
                              aria-controls="collapseTwo"
                            >
                              <MdGridView />
                              Functional
                            </button>
                          </h5>
                          <GreenSwitch
                            checked={tempSwitchStates.functional}
                            onChange={() =>
                              setTempSwitchStates((prev) => ({
                                ...prev,
                                functional: !prev.functional,
                              }))
                            }
                          />
                        </div>

                        <div
                          id="collapseTwo"
                          className="collapse"
                          aria-labelledby="headingTwo"
                          data-parent="#accordion"
                        >
                          <div className="card-body !py-[12px] !px-0 !font-normal !text-[14px] leading-normal">
                            Remember your preferred domain search filters? These
                            clever cookies do the memorizing for you,
                            personalizing your experience and keeping your
                            domain hunt efficient.
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <div id="accordion" className="w-full">
                      <div className="w-full">
                        <div
                          className="card-header p-0 flex justify-between align-items-center"
                          id="headingThree"
                        >
                          <h5 className="mb-0 !mt-[-3px]">
                            <button
                              className="btn btn-link p-0 !min-h-fit !h-fit text-[16px] text-[#4f4f4f]"
                              data-toggle="collapse"
                              data-target="#collapseThree"
                              aria-expanded="true"
                              aria-controls="collapseThree"
                            >
                              <MdOutlineSettings />
                              Performance
                            </button>
                          </h5>
                          <GreenSwitch
                            checked={tempSwitchStates.performance}
                            onChange={() =>
                              setTempSwitchStates((prev) => ({
                                ...prev,
                                performance: !prev.performance,
                              }))
                            }
                          />
                        </div>

                        <div
                          id="collapseThree"
                          className="collapse"
                          aria-labelledby="headingThree"
                          data-parent="#accordion"
                        >
                          <div className="card-body !py-[12px] !px-0 !font-normal !text-[14px] leading-normal">
                            Making sure your search and cart are super fast and
                            responsive is our goal. These cookies ensure the
                            technical performance of our website stays
                            top-notch, so you can seamlessly find and secure
                            your ideal .gold domain.
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </Box>
            </div>
            <div className="w-[100%] line-divv !mt-0 !mb-0"></div>
            <div className="p-3 flex justify-between align-items-center cookies-footer">
              <div className="flex justify-between cookies-footer gap-[10px]">
                <div>
                  <button
                    onClick={handleRejectAll}
                    className="join-btn custom-btn main-buttonn w-full !text-[#563a2d]"
                    style={{
                      backgroundColor: "white",
                      width: "100%",
                    }}
                  >
                    Reject All
                  </button>
                </div>
                <div>
                  <button
                    onClick={handleAcceptAll}
                    className="join-btn custom-btn main-button w-full !text-[#563a2d]"
                    style={{
                      backgroundColor: "white",
                      width: "100%",
                    }}
                  >
                    Accept All
                  </button>
                </div>
              </div>

              <div className="cookies-footer">
                <button
                  onClick={handleSaveSettings}
                  className="join-btn custom-btn main-buttonn w-full !text-[#563a2d]"
                  style={{
                    backgroundColor: "white",
                    width: "100%",
                  }}
                >
                  Save Settings
                </button>
              </div>
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
};
